import styled, { keyframes, css } from 'styled-components';
import { SIZE } from 'common/sizes';
import { COLOR_PALETTE } from 'common/colors';
import { DEFAULT_FONT_FAMILY } from 'common/constants';

const appear = keyframes`
    from {transform: translateY(${SIZE.TWENTYFOUR}px); opacity: 0;}
    to { transform: translateY(0); opacity: 1;}
`

const appearAnimation = props =>
    css`
    ${appear} 0.350s ease-out;
`
const disappear = keyframes`
    from { transform: translateY(0); opacity: 1;}
    to {transform: translateY(${SIZE.TWENTYFOUR}px); opacity: 0;}
    
`

const disappearAnimation = props =>
    css`
    ${disappear} 0.350s ease-out;
`

export interface ContainerProps {
    shouldShow: boolean;
}
export const Container = styled.div`
    display:flex;
    flex-flow: column;
    background: #FFF;
    width: ${SIZE.EIGHTY_TWO}px;
    height: ${SIZE.THIRTY_SIX}px;

    border: 1px solid #A0A0A0;
    padding: ${SIZE.SIX}px;
    animation: ${(props: ContainerProps) => props.shouldShow ? appearAnimation : disappearAnimation};
    animation-fill-mode: forwards;
    border-radius: 3px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12);
    
`

export const ErrorMsg = styled.span`
    margin-top: 0px;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    background-image: linear-gradient(to top, #f36868, #f66000);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    display: flex;
    flex-flow: column;
`
